import { z } from 'zod';
import { parseOptionalNonNegativeNumber } from '../../parse-optional-non-negative-number.js';
export const optionalNonNegativeNumberString = (label) => z.string().superRefine((value, context) => {
    const result = parseOptionalNonNegativeNumber(value, label);
    if (typeof result === 'string') {
        context.addIssue({
            code: 'custom',
            message: result,
            path: [],
        });
    }
});
//# sourceMappingURL=optional-non-negative-number-string.js.map